import { render, staticRenderFns } from "./flowInstanceNodeHistory.vue?vue&type=template&id=19a8f5e2&scoped=true&lang=pug"
import script from "./flowInstanceNodeHistory.vue?vue&type=script&lang=js"
export * from "./flowInstanceNodeHistory.vue?vue&type=script&lang=js"
import style0 from "./flowInstanceNodeHistory.vue?vue&type=style&index=0&id=19a8f5e2&prod&lang=scss&scoped=true"
import style1 from "./flowInstanceNodeHistory.vue?vue&type=style&index=1&id=19a8f5e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8f5e2",
  null
  
)

export default component.exports